var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"b-errorModal":"","id":"errorModal","hide-header-close":"","ok-only":"","title":"Ocorreu um erro"}},[_c('div',{staticClass:"container-fluid m-0 p-0"},[_c('p',[_vm._v("\n            "+_vm._s(_vm.text)+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f94f076","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErrorModal.vue
// module id = 1358
// module chunks = 5